// Baseline dictionary. Its keys are the contract: every locale file must map
// each MessageKey (enforced by Record<MessageKey, string>), and t() falls back
// to these strings when a locale chunk is missing one (or failed to load).
// Keys are namespaced by surface: nav.*, common.*, home.*, race.*, …
export const en = {
  "nav.home": "Home",
  "nav.world": "World",
  "nav.polls": "Polls",
  "nav.candidates": "Candidates",
  "nav.howItWorks": "How it works",
  "nav.pickNation": "Pick your nation",
  "nav.changeNation": "Change nation",
  "nav.search": "Search…",
  "common.hide": "Hide",
  "common.show": "Show",
  "account.account": "Account",
  "account.verified": "Verified",
  "account.verifiedCandidate": "Verified candidate",
  "account.tokenBlurb": "Your edit token unlocks every campaign you own. Copy it to manage them on another device.",
  "account.copied": "Copied",
  "account.copyToken": "Copy token",
  "account.forgetToken": "Forget token on this device",
  "account.haveToken": "Have a token?",
  "account.restoreBlurb": "Paste an edit token to manage your campaigns on this device. Get one by verifying ownership on your candidate page.",
  "account.pastePlaceholder": "paste your token",
  "account.restore": "Restore",
  "nation.choose": "Choose your nation",
  "search.title": "Search",
  "search.countries": "Countries",
  "search.countryPlaceholder": "Search country…",
  "search.noMatches": "No matches.",
  "common.close": "Close",
  "common.loading": "Loading…",
  "common.loadingCountries": "Loading countries…",
  "common.seeAll": "see all",
  "common.removeFavorite": "Remove favorite",
  "common.addFavorite": "Add favorite",
  "common.updatedAgo": "Updated {ago}",
  "common.justNow": "just now",
  "common.minutesAgo": "{n}m ago",
  "common.hoursAgo": "{n}h ago",
  "common.daysAgo": "{n}d ago",
  "share.tooltip": "Share this page",
  "share.copied": "Link copied",
  "share.share": "Share",
  "phase.live": "LIVE",
  "phase.soon": "SOON",
  "phase.done": "DONE",
  "phase.inMinutes": "IN {n}M",
  "phase.inHours": "IN {n}H",
  "phase.inDays": "IN {n}D",
  "ticker.liveCloses": "live · closes {date}",
  "ticker.opens": "opens {date}",
  "office.president": "president",
  "office.congress": "congress",
  "badge.imported": "imported",
  "badge.imported.tip": "Auto-generated from this player's WarEra campaign article. Once the real player verifies and edits it, it becomes their own first-party content.",
  "badge.declared": "declared",
  "badge.declared.tip": "First-party content written here by the candidate (or edited by them). Provenance only — see the verified badge for whether the player proved ownership.",
  "badge.verified": "✓ verified",
  "badge.verified.tip": "The real player proved they control this WarEra account (renamed one of their companies to a one-time code we checked via the WarEra API).",
  "badge.pending": "pending review",
  "badge.pending.tip": "Scraped from this player's WarEra campaign article and awaiting admin approval. Not shown publicly until approved.",
  "badge.hidden": "hidden",
  "badge.hidden.tip": "Hidden by an admin (impersonation or abuse). Not shown publicly.",
  "activity.loading": "Loading activity…",
  "activity.empty": "No recent activity yet.",
  "activity.newCandidacy": "New candidacy:",
  "activity.updatedCampaign": "updated their campaign",
  "activity.newQuestionFor": "New question for",
  "activity.answered": "answered a question",
  "activity.newPoll": "New community poll",
  "activity.postedUpdate": "posted a campaign update",
  "common.back": "Back",
  "common.retry": "Retry",
  "common.cancel": "Cancel",
  "common.submit": "Submit",
  "common.submitting": "Submitting…",
  "common.independent": "Independent",
  "common.loadingElections": "Loading elections…",
  "office.presidentTitle": "President",
  "office.congressTitle": "Congress",
  "home.kicker": "First, choose your nation",
  "home.pickSide": "PICK YOUR SIDE.",
  "home.onboardBlurb": "WarUrna centers on your country's elections — like following your team. Pick one now; you'll land straight in its war-room every visit. The rest of the world stays one tab away.",
  "home.yourNation": "Your nation",
  "home.raceLive": "race live now",
  "home.racesLive": "races live now",
  "home.activeVoters": "active voters",
  "home.candidateRunning": "candidate running",
  "home.candidatesRunning": "candidates running",
  "home.declareCandidacy": "Declare candidacy",
  "home.yourRaces": "Your races",
  "home.loadingRaces": "Loading races…",
  "home.fromTrail": "From the trail",
  "home.allCandidates": "all candidates",
  "home.measuresCount": "{n} measures",
  "home.readPlatform": "read platform",
  "home.latestIn": "Latest in {nation}",
  "home.nationPolls": "{nation} polls",
  "home.allPolls": "all polls",
  "home.aroundWorld": "Around the world",
  "home.fullFeed": "full feed",
  "world.title": "Around the World",
  "world.blurb": "This month's elections across every nation.",
  "world.filter.all": "All",
  "world.filter.live": "Live",
  "world.filter.upcoming": "Upcoming",
  "world.filter.decided": "Decided",
  "world.empty": "No elections to show.",
  "world.emptyUpcoming": "No upcoming elections on record yet — your nation's next races are on its home page.",
  "country.allCountries": "All countries",
  "country.noElections": "No elections found.",
  "leaderboard.title": "Most engaged countries",
  "leaderboard.blurb": "Ranked by turnout — least abstention first. Turnout = votes cast ÷ active citizens (latest voted election).",
  "leaderboard.computing": "Computing turnout…",
  "leaderboard.empty": "No turnout data yet — check back after the next refresh.",
  "race.backToElections": "Back to elections",
  "race.candidatesCampaigns": "candidates & campaigns",
  "race.shareTitle": "{office} race",
  "race.shareText": "See who's running on WarUrna",
  "race.loadingCandidates": "Loading candidates…",
  "race.noDeclared": "No one has declared yet. Be the first.",
  "race.declare": "Declare your candidacy",
  "race.electsSeats": "elects {n} seats (multiple winners)",
  "race.concluded": "Race concluded · held {date}",
  "race.underway": "Race underway · started {date}",
  "race.upcoming": "Upcoming race · opens {date}",
  "race.selfReported": "Declarations here are self-reported until the official candidate list confirms them",
  "race.selfReportedDone": "Declarations here are self-reported and may differ from the official result",
  "race.form.username": "Your WarEra username",
  "race.form.usernamePlaceholder": "exact in-game username",
  "race.form.party": "Party (optional)",
  "race.form.partyPlaceholder": "your party, or leave blank for independent",
  "race.form.manifesto": "Manifesto (optional)",
  "race.form.manifestoPlaceholder": "Why you're running…",
  "race.form.measures": "Measures you'd implement",
  "race.form.verifyNote": "After submitting, verify you own this WarEra account (a 30-second company-rename check) to unlock editing. One verification unlocks every campaign you own.",
  "forecast.warming": "Crunching this forecast for the first time — WarEra data is still loading. Give it a moment.",
  "forecast.votingClosed": "Voting closed — this election has finished. Votes are no longer accepted.",
  "forecast.votingOpens": "voting opens {date}",
  "forecast.liveTurnout": "live · turnout {pct}%",
  "forecast.closedTurnout": "closed · turnout {pct}%",
  "forecast.viewCandidates": "View candidates & campaigns",
  "forecast.shareTitle": "{country} {office} election — forecast",
  "forecast.shareText": "Live forecast on WarUrna",
  "forecast.candidate": "Candidate",
  "forecast.updating": "Updating…",
  "forecast.forecast": "Forecast",
  "forecast.result": "Result",
  "forecast.actual": "Actual",
  "forecast.incumbent": "incumbent",
  "forecast.rulingParty": "ruling party",
  "forecast.lvlDmg": "lvl {lvl} · {dmg} dmg",
  "forecast.blendNote.early": "Forecast = projection (crowd factored in as votes accumulate).",
  "forecast.blendNote.blended": "Forecast = projection blended with the crowd.",
  "forecast.winner": "Winner",
  "forecast.elected": "Elected ({n})",
  "forecast.candidateStats": "Candidate stats",
  "forecast.showCurrent": "Show current stats",
  "forecast.showAtElection": "Show stats at election time",
  "forecast.statsSnapshot": "Stats captured at the close of this election.",
  "forecast.statsLive": "Live stats from the WarEra API.",
  "forecast.posts": "Posts",
  "forecast.loadingPosts": "Loading posts…",
  "forecast.noPosts": "No posts found",
  "forecast.untitled": "Untitled article",
  "forecast.yourVote": "Your vote",
  "forecast.whoVote": "Who will you vote for?",
  "forecast.nicknamePlaceholder": "Nickname (optional)",
  "forecast.voteRecorded": "Vote recorded. Changing it updates, doesn't duplicate.",
  "forecast.whyNumbers": "Why these numbers?",
  "forecast.factorScore": "score {score} → {pct}%",
  "forecast.howCalculated": "How is this calculated?",
  "forecast.crowdVotes": "{n} crowd votes · weight {pct}% (full at {full})",
  "forecast.pollVotes": "{n} votes",
  "how.title": "How the forecast works",
  "how.intro": "Every forecast on WarUrna is a transparent formula — not a black box and not machine learning. Here is exactly how each number is built.",
  "how.modelHeading": "1. The projection model",
  "how.modelBody": "Each candidate earns points from {n} factors. Every factor is scored from 0 to 1, multiplied by its weight, then added up into a total score. Heavier weights move the needle more.",
  "how.factorsHeading": "Factors & weights",
  "how.weightLabel": "weight {w}",
  "how.winHeading": "2. From score to win %",
  "how.winBody": "A candidate's win % is their share of all candidates' scores combined, so the percentages always add up to 100%. If every candidate scores zero, the race is split evenly.",
  "how.blendHeading": "3. Blending in the reader poll",
  "how.blendBody": "The reader poll on each forecast is folded into the displayed number. The crowd's influence starts at zero and ramps up to full once a poll reaches {n} votes — so a few early votes barely move the forecast, while a well-voted poll can shift it a lot.",
  "how.blendFormula": "Forecast = projection × (1 − crowd weight) + crowd share × crowd weight",
  "how.confidenceHeading": "4. A word on confidence",
  "how.confidenceBody": "This is a projection, not a promise. It leans on public stats and a small reader poll, so read it as an informed estimate — the real outcome is whatever the in-game ballots decide.",
  "how.backToForecasts": "Browse forecasts",
  "model.factor.careerDamage.label": "Career damage",
  "model.factor.careerDamage.desc": "Total damage dealt across the player's career, on a log scale so the biggest hitters rank highest.",
  "model.factor.incumbent.label": "Incumbent president",
  "model.factor.incumbent.desc": "Currently holds the office being contested.",
  "model.factor.rulingParty.label": "Ruling party",
  "model.factor.rulingParty.desc": "Runs with the country's governing party.",
  "model.factor.level.label": "Level",
  "model.factor.level.desc": "Account level, counted up to 100.",
  "model.factor.premium.label": "Premium months",
  "model.factor.premium.desc": "Months of premium subscription, counted up to 24.",
  "model.factor.subscribers.label": "Subscribers",
  "model.factor.subscribers.desc": "Newspaper subscribers, counted up to 50.",
  "model.factor.military.label": "Military rank",
  "model.factor.military.desc": "In-game military rank.",
  "model.factor.campaign.label": "Campaign article",
  "model.factor.campaign.desc": "Published a campaign article for this race.",
  "stats.level": "Level",
  "stats.careerDmg": "Career dmg",
  "stats.militaryRank": "Military rank",
  "stats.wealth": "Wealth",
  "stats.premium": "Premium",
  "stats.subscribers": "Subscribers",
  "stats.pastElections": "Past elections",
  "stats.playingSince": "Playing since",
  "stats.lastActive": "Last active",
  "stats.referrals": "Referrals",
  "candidacy.playerStats": "Player stats",
  "candidacy.viewRace": "View race",
  "candidacy.statsUnavailable": "Player stats unavailable for this candidate.",
  "common.copy": "Copy",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.remove": "Remove",
  "candidacy.allCandidates": "All candidates",
  "candidacy.loadingCandidate": "Loading {name}…",
  "candidacy.shareTitle": "{name} — {office} candidate",
  "candidacy.shareText": "{name}'s campaign on WarUrna",
  "candidacy.created.title": "Your campaign is live",
  "candidacy.created.body": "To edit it and answer questions, verify you own this WarEra account — use the “Verify ownership” option at the bottom of the page. It takes ~30 seconds and unlocks every campaign you own.",
  "candidacy.restoreHint": "Already verified on another device? Restore your token from the Account menu (top right).",
  "candidacy.areYou": "Are you {name}? Verify ownership to manage",
  "candidacy.verifyOwn": "Verify you own {name}",
  "candidacy.verifyBlurb": "We'll check it via the WarEra API — no password, no waiting on an admin. This unlocks every campaign you own.",
  "candidacy.starting": "Starting…",
  "candidacy.startVerification": "Start verification",
  "candidacy.renameStep": "In WarEra, rename any one of your companies to:",
  "candidacy.verifyStep": "Then click Verify (the code is valid ~30 min). You can rename it back afterwards.",
  "candidacy.checking": "Checking…",
  "candidacy.verifyNow": "Verify now",
  "candidacy.party": "Party",
  "candidacy.partyPlaceholder": "leave blank for independent",
  "candidacy.manifesto": "Manifesto",
  "candidacy.measures": "Measures",
  "candidacy.noManifesto": "No manifesto yet.",
  "candidacy.sources": "Sources",
  "candidacy.autoGenerated": "This summary was auto-generated from the sources above.",
  "candidacy.editCampaign": "Edit campaign",
  "profile.loading": "Loading {name}…",
  "profile.playerStats": "Player stats",
  "profile.statsPending": "Stats are warming up — check back in a moment.",
  "profile.currentCampaign": "Current campaign",
  "profile.viewCampaign": "View campaign",
  "profile.electionHistory": "Election history",
  "profile.noElections": "No recorded elections for this player.",
  "profile.pastCandidacies": "Past candidacies",
  "profile.noCandidacies": "No candidacies on record.",
  "profile.elected": "Elected",
  "profile.notElected": "Not elected",
  "profile.rankOf": "{rank} of {total}",
  "profile.seats": "{count} seats",
  "profile.votes": "{count} votes",
  "profile.shareTitle": "{name} — WarEra profile",
  "profile.shareText": "{name}'s elections and campaigns on WarUrna",
  "profile.viewOnWarera": "View on WarEra",
  "ama.title": "Ask Me Anything",
  "ama.askPlaceholder": "Ask this candidate a question…",
  "ama.namePlaceholder": "Your name (optional)",
  "ama.posting": "Posting…",
  "ama.ask": "Ask",
  "ama.noQuestions": "No questions yet.",
  "ama.upvote": "Upvote",
  "ama.asked": "{name} asked",
  "ama.anonymous": "Anonymous",
  "ama.candidateAnswered": "candidate answered",
  "ama.answer": "Answer",
  "ama.unanswered": "unanswered",
  "polls.title": "Community polls",
  "polls.blurb": "Ask anything. Anyone can vote — no login. Attach a poll to your nation or keep it global.",
  "polls.loading": "Loading polls…",
  "polls.loadingPoll": "Loading poll…",
  "polls.allPolls": "All polls",
  "polls.shareText": "Vote on WarUrna",
  "polls.nationCommunity": "{nation} community",
  "polls.emptyNation": "No polls for your nation yet — be the first.",
  "polls.global": "Global",
  "polls.emptyGlobal": "No global polls yet.",
  "polls.otherNations": "Other nations",
  "polls.create": "Create a poll",
  "polls.question": "Question",
  "polls.questionPlaceholder": "What do you want to ask?",
  "polls.options": "Options",
  "polls.optionN": "Option {n}",
  "polls.addOption": "Add option",
  "polls.attachTo": "Attach to:",
  "polls.post": "Post poll",
  "polls.votesTap": "{n} votes · tap to change",
  "polls.tapToVote": "tap an option to vote",
  // Voter-eligibility gating (verified / min-level)
  "polls.requireVerified": "Verified voters only",
  "polls.requireVerifiedHint": "Only players who've proved their WarEra account can vote.",
  "polls.minLevel": "Minimum level",
  "polls.minLevelHint": "Voters below this level can't vote. A minimum level requires verified voters.",
  "polls.minLevelPlaceholder": "No minimum",
  "polls.badgeVerified": "✓ Verified",
  "polls.badgeLevel": "✓ Lvl {n}+",
  "polls.needsVerification": "This poll is open to verified players only.",
  "polls.levelTooLow": "This poll needs level {required}. You're level {current}.",
  "polls.verifyCta": "Verify your account",
  // Closing time (scheduled end date + verified-owner manual close)
  "polls.endDate": "Closing time",
  "polls.endDays": "{n}d",
  "polls.endCustom": "Custom",
  "polls.endNone": "No end date",
  "polls.endHint": "Voters can't vote after this time.",
  "polls.endRequiredHint": "Pick a closing time. Verify your account to leave a poll open and close it yourself.",
  "polls.endVerifyPrompt": "Verify your account to leave this poll open with no closing time.",
  "polls.closesInDays": "Closes in {n}d",
  "polls.closesInHours": "Closes in {n}h",
  "polls.closesInMins": "Closes in {n}m",
  "polls.closedVotes": "{n} votes · closed",
  "polls.closeNow": "Close this poll",
  "polls.winner": "Winner",
  // Standalone account verification (any player, not just candidates)
  "verify.title": "Verify your WarEra account",
  "verify.intro": "Prove you control your account to vote on gated polls. One verification works across this device.",
  "verify.usernameLabel": "WarEra username",
  "verify.getCode": "Get code",
  "verify.verifyBtn": "Verify",
  "verify.success": "Verified — you can vote now.",
  "candidates.title": "Candidates",
  "candidates.blurb": "Everyone running across WarEra — their party, platform, and AMA.",
  "candidates.allNations": "All nations",
  "candidates.empty": "No candidates yet — be the first to run.",
  "candidates.run": "Run for office",
  "candidates.pickFirst": "Pick your nation first (top bar) to run for office there.",
  "candidates.runIn": "Run for office in {nation}",
  "candidates.runBlurb": "Pick the office you're running for. Next you'll add your platform and verify you own the account.",
  "measures.titlePlaceholder": "Measure title",
  "measures.detailPlaceholder": "Details (optional)",
  "measures.add": "Add measure",
  "election.notOpen": "Not open yet",
  "election.opens": "opens {date}",
  "election.closes": "closes {date}",
  "election.closedOn": "closed {date}",
  "election.closed": "Closed",
  "election.nElected": "{n} elected",
  "election.finalResult": "final result",
  "election.projectedFavorite": "projected favorite",
  "election.winProb": "WIN PROB",
  "election.noCandidates": "No candidates yet",
  "election.liveLeader": "live: {name} {votes}",
  "worldCard.live": "live · {pct}% turnout · closes {date}",
  "worldCard.decided": "decided · {pct}% turnout",
  "loader.headline.forecast": "Building the forecast",
  "loader.stage.election": "Reading the race…",
  "loader.stage.country": "Loading the nation…",
  "loader.stage.history": "Pulling election history…",
  "loader.stage.candidates": "Tallying candidate strength…",
  "loader.wait.contacting": "Reaching WarEra…",
  "loader.wait.fetching": "Gathering the latest data…",
  "loader.wait.slow": "Still working — WarEra's busy, hang tight…",
  "loader.state.rateLimited": "WarEra's asking us to slow down — waiting for it to let us back in…",
  "loader.state.busy": "WarEra's servers are having a moment — retrying…",
} as const;

export type MessageKey = keyof typeof en;
